import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import MyWallet from 'components/pages/Statistics/StatisticsContent/Grids/components/MyWallet'
import NextClass from 'components/pages/Statistics/StatisticsContent/Grids/components/NextClass'
import TopCategories from 'components/pages/Statistics/StatisticsContent/Grids/components/TopCategories'
import MyProfileStudent from 'components/pages/Statistics/StatisticsContent/Grids/components/MyProfileStudent'
import Quizzes from 'components/pages/Statistics/StatisticsContent/Grids/components/Quizzes'
import TopTutors from 'components/pages/Statistics/StatisticsContent/Grids/components/TopTutors'
import News from 'components/pages/Statistics/StatisticsContent/Grids/components/News'
import ClassesGraphic from './ClassesGraphic'

import { getStudentStats } from '../../../routing/fetchingfunction/dashboard/dashboard.action'
import {
  selectStudentQuizzesStats,
  selectTopCategories,
} from '../../../routing/fetchingfunction/dashboard/dashboard.reducer'

import { statisticBreakdowns, statisticIntervals } from '../../../constants'

const Statistic = () => {
  const dispatch = useDispatch()

  const topCategories = useSelector(selectTopCategories)
  const studentQuizzes = useSelector(selectStudentQuizzesStats)

  const [interval, setInterval] = useState(statisticIntervals[0])

  useEffect(() => {
    dispatch(
      getStudentStats({ period: interval.toLowerCase(), breakdown: statisticBreakdowns[interval] })
    )
  }, [dispatch, interval])

  return (
    <div className="max-w-7xl">
      <div className="h-72 w-100 flex mb-3">
        <MyWallet containerClassName="w-25 me-2" />
        <NextClass containerClassName="w-25 me-2" />
        <TopCategories
          topCategories={topCategories}
          containerClassName="w-25 me-2"
          doughnutWrapperClassName="w-[144px]"
          firstCircleSize={62}
          secondCircleSize={48}
          thirdCircleSize={34}
        />
        <MyProfileStudent containerClassName="w-25" />
      </div>

      <div>
        <div className="grid grid-cols-3 gap-2 mb-2">
          <Quizzes quizzes={''} />
          <TopTutors topTutors={[]} title="Favourite Tutors" />
          <News className="max-h-[207px]" />
        </div>
      </div>

      <ClassesGraphic interval={interval} onIntervalChange={setInterval} />
    </div>
  )
}

export default Statistic
